import * as React from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import ButtonOrange from "@shared/uiNew/Button/button_orange";
import * as styles from "./RoleLanding.module.scss";

export type FeatureCard = {
  title: string;
  text: string;
  image?: string;
};

export type FaqItem = {
  question: string;
  answer: string;
};

type Props = {
  hero: {
    title: string;
    subtitle: string;
    image: string;
    imageAlt: string;
  };
  featuresHeading: string;
  features: FeatureCard[];
  comingSoon?: {
    title: string;
    text: string;
    image?: string;
  };
  finalCta: {
    title: string;
    videoSrc?: string;
  };
  faq?: { heading?: string; items: FaqItem[] };
};

export const RoleLanding = ({ hero, featuresHeading, features, comingSoon, finalCta, faq }: Props) => {
  return (
    <>
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <div>
            <h1 className={styles.heroTitle}>{hero.title}</h1>
            <p className={styles.heroSub}>{hero.subtitle}</p>
            <div className={styles.heroButtons}>
              <ButtonBlack icon="arrow" text="Try Dashly for free" href="/panel/unauthorized/register" />
              <ButtonBlack variant="outline" text="Book a demo" href="/demo/" />
            </div>
          </div>
          <img src={hero.image} alt={hero.imageAlt} className={styles.heroImage} loading="eager" />
        </div>
      </section>

      <section className={`${styles.section} ${styles.alt}`}>
        <div className={styles.sectionInner}>
          <h2 className={styles.sectionHeading}>{featuresHeading}</h2>
          <div className={styles.featureGrid}>
            {features.map((f) => (
              <div key={f.title} className={styles.featureCard}>
                {f.image && <img src={f.image} alt={f.title} className={styles.featureImage} loading="lazy" />}
                <h3 className={styles.featureTitle}>{f.title}</h3>
                <p className={styles.featureText}>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {comingSoon && (
        <section className={styles.comingSoon}>
          <div className={styles.comingSoonInner}>
            <div>
              <h2 className={styles.comingSoonTitle}>{comingSoon.title}</h2>
              <p className={styles.comingSoonText}>{comingSoon.text}</p>
              <ButtonOrange icon="arrow" text="Apply for beta access" href="#open-demo-pop-up" />
            </div>
            {comingSoon.image && <img src={comingSoon.image} alt="Chatbot in messengers" className={styles.heroImage} loading="lazy" />}
          </div>
        </section>
      )}

      <section className={styles.cta}>
        <div className={styles.ctaInner}>
          <h2 className={styles.ctaTitle}>{finalCta.title}</h2>
          {finalCta.videoSrc && (
            <video
              className={styles.ctaVideo}
              src={finalCta.videoSrc}
              autoPlay
              muted
              loop
              playsInline
              controls={false}
            />
          )}
          <div className={styles.ctaButtons}>
            <ButtonBlack icon="arrow" text="Try Dashly for free" href="/panel/unauthorized/register" />
            <ButtonBlack variant="outline" text="Book a demo" href="/demo/" />
          </div>
        </div>
      </section>

      {faq && faq.items.length > 0 && (
        <section className={`${styles.section} ${styles.alt}`}>
          <div className={styles.sectionInner}>
            <h2 className={styles.sectionHeading}>{faq.heading || "Frequently asked questions"}</h2>
            <div className={styles.faqWrap}>
              {faq.items.map((it) => (
                <div key={it.question} className={styles.faqItem}>
                  <h3 className={styles.faqQuestion}>{it.question}</h3>
                  <p className={styles.faqAnswer}>{it.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default RoleLanding;
